// extracted by mini-css-extract-plugin
module.exports = {"withdrawalSnippet":"style_withdrawalSnippet__3uqKA","info":"style_info__2VOp0","unread":"style_unread___tEa5"};